import { render, staticRenderFns } from "./ReportSection.vue?vue&type=template&id=27688bf0"
import script from "./ReportSection.vue?vue&type=script&lang=js"
export * from "./ReportSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports